import React from 'react';
import { useStore } from '../../stores/useStore';

export const TabLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { activeTab, setActiveTab, setSelectedSchedule, user, signOut, profiles } = useStore();
    const myProfile = profiles.find((p) => p.id === user?.id);

    const tabs = [
        { id: 'schedule', label: '일정',   icon: '📅' },
        { id: 'work',     label: '작업',   icon: '📋' },
        { id: 'inventory',label: '재고',   icon: '📦' },
        { id: 'client',   label: '거래처', icon: '🏢' },
        { id: 'tools',    label: '도구',   icon: '🔧' },
        { id: 'my',       label: '마이',   icon: '👤' },
    ];

    const handleTabChange = (tabId: string) => {
        setActiveTab(tabId);
        setSelectedSchedule(null);
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            backgroundColor: '#d8d0c5',
            maxWidth: '480px',
            margin: '0 auto',
            borderLeft: '1px solid #b8b0a5',
            borderRight: '1px solid #b8b0a5',
            boxShadow: '0 0 20px rgba(0,0,0,0.15)'
        }}>
            <header style={{
                backgroundColor: '#1e3a5f',
                color: 'white',
                padding: '16px',
                paddingTop: 'calc(env(safe-area-inset-top) + 16px)',
                borderBottom: '3px solid #c75c2e',
                position: 'relative'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div>
                        <h1 style={{
                            fontSize: '18px',
                            fontWeight: 700,
                            letterSpacing: '2px',
                            fontFamily: "'Noto Sans KR', sans-serif"
                        }}>
                            범양공조
                        </h1>
                        <p style={{
                            fontSize: '11px',
                            color: '#a0b4c8',
                            marginTop: '2px',
                            letterSpacing: '1px'
                        }}>
                            HVAC MANAGEMENT SYSTEM
                        </p>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '4px' }}>
                        {(myProfile?.name || user?.email) && (
                            <span style={{ fontSize: '11px', color: '#a0b4c8', letterSpacing: '0.3px' }}>
                                {myProfile?.name || user!.email!.replace('@beomyang.local', '')}
                            </span>
                        )}
                        <button
                            onClick={signOut}
                            style={{
                                padding: '4px 10px',
                                backgroundColor: 'rgba(255,255,255,0.1)',
                                border: '1px solid rgba(255,255,255,0.2)',
                                borderRadius: '10px',
                                color: '#a0b4c8',
                                fontSize: '12px',
                                cursor: 'pointer',
                                fontFamily: "'Noto Sans KR', sans-serif",
                            }}
                        >
                            로그아웃
                        </button>
                    </div>
                </div>
            </header>

            <main style={{ flex: 1, overflowY: 'auto' }}>
                {children}
            </main>

            <nav style={{
                backgroundColor: '#f4f1ea',
                borderTop: '2px solid #b8b0a5',
                paddingBottom: 'env(safe-area-inset-bottom)'
            }}>
                <div style={{ display: 'flex' }}>
                    {tabs.map((tab) => {
                        const isActive = activeTab === tab.id;
                        return (
                            <button
                                key={tab.id}
                                onClick={() => handleTabChange(tab.id)}
                                style={{
                                    flex: 1,
                                    padding: '8px 2px 6px',
                                    backgroundColor: 'transparent',
                                    color: isActive ? '#1e3a5f' : '#a09890',
                                    border: 'none',
                                    borderRight: '1px solid #e8e0d5',
                                    cursor: 'pointer',
                                    transition: 'all 0.15s',
                                    position: 'relative',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: '2px',
                                }}
                            >
                                {isActive && (
                                    <div style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: '10%',
                                        width: '80%',
                                        height: '2px',
                                        backgroundColor: '#c75c2e',
                                    }} />
                                )}
                                <span style={{ fontSize: '18px', lineHeight: 1 }}>{tab.icon}</span>
                                <span style={{
                                    fontSize: '10px',
                                    fontWeight: isActive ? 700 : 400,
                                    letterSpacing: '0.3px',
                                    fontFamily: "'Noto Sans KR', sans-serif",
                                }}>
                                    {tab.label}
                                </span>
                            </button>
                        );
                    })}
                </div>
            </nav>
        </div>
    );
};